import React from 'react';

import styled, { css } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPhone,
  faEnvelope,
  faMobile,
  faMapMarker,
  faFax,
  faSearch
} from '@fortawesome/pro-light-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';

library.add({ faPhone, faEnvelope, faMobile, faMapMarker, faFax, faSearch });

export const IconWrapperCSS = css`
  left: 0;
  display: block;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  color: ${props =>
    props.theme.name === 'Skjernbank'
      ? props.theme.colors.palette.red
      : 'grey'};
`;

const IconWrapper = styled.div`
  ${IconWrapperCSS}
`;
const SearchIconWrapper = styled.div`
  ${IconWrapperCSS}
  width: 21px;
  top: 52%;
  left: 90%;
`;

export function FaxIcon() {
  return (
    <IconWrapper>
      <FontAwesomeIcon icon={['fal', 'fax']} size="1x" />
    </IconWrapper>
  );
}

export function PhoneIcon() {
  return (
    <IconWrapper>
      <FontAwesomeIcon icon={['fal', 'phone']} size="1x" />
    </IconWrapper>
  );
}

export function EnvelopeIcon() {
  return (
    <IconWrapper>
      <FontAwesomeIcon icon={['fal', 'envelope']} size="1x" />
    </IconWrapper>
  );
}

export function MobileIcon() {
  return (
    <IconWrapper>
      <FontAwesomeIcon icon={['fal', 'mobile']} size="1x" />
    </IconWrapper>
  );
}

export function SearchIcon() {
  return (
    <SearchIconWrapper>
      <FontAwesomeIcon icon={['fal', 'search']} size="lg" />
    </SearchIconWrapper>
  );
}

export function MapmarkerIcon() {
  return (
    <IconWrapper>
      <FontAwesomeIcon icon={['fal', 'map-marker']} size="1x" />
    </IconWrapper>
  );
}
